import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/administration/email-settings',
)({
  component: () => (
    <div>Hello /_authenticated/administration/email-settings!</div>
  ),
})
